import SendPinRequest from '../entities/SendPinRequest'
import { IUserRepository } from '../repositories/IUserRepository'

export interface ISendPin {
  execute(params: SendPinRequest): Promise<void>
}

export default class SendPinImpl implements ISendPin {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(params: SendPinRequest): Promise<void> {
    await this.userRepository.sendPin(params)
  }
}
